import {
  INVOICES_LOADING,
  INVOICES_LOADED,
  CREATE_QB_INVOICE_LOADING,
  CREATE_QB_INVOICE_SUCCESS,
  CREATE_QB_INVOICE_FAILED,
  PAY_PREPAID_INVOICE_LOADING,
  PAY_PREPAID_INVOICE_SUCCESS,
  PAY_PREPAID_INVOICE_FAILED,
  TAX_RATES_LOADING,
  TAX_RATES_LOADED,
  TAX_RATES_FAILED,
  CUSTOMER_TAX_INFO_LOADING,
  CUSTOMER_TAX_INFO_SUCCESS,
  CUSTOMER_TAX_INFO_FAILED,
} from '../actions/types';

const initialState = {
  loading: false,
  success: false,
  data: {
    contents: [],
    totalPages: 0,
  },
  createInvoice: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  payPrepaidInvoice: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  taxRates: {
    loading: false,
    data: [],
    error: null,
  },
  customerTaxInfo: {
    loading: false,
    data: null,
    error: null,
  },
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVOICES_LOADING:
      return {
        ...state,
        loading: true,
        success: false,
        loaded: false,
        data: [],
      };
    case INVOICES_LOADED:
      return {
        ...state,
        loading: false,
        success: false,
        data: action.payload,
      };
    case CREATE_QB_INVOICE_LOADING:
      return {
        ...state,
        createInvoice: {
          ...state.createInvoice,
          loading: true,
          success: false,
          error: null,
        },
      };
    case CREATE_QB_INVOICE_SUCCESS:
      return {
        ...state,
        createInvoice: {
          loading: false,
          success: true,
          error: null,
          data: action.payload,
        },
      };
    case CREATE_QB_INVOICE_FAILED:
      return {
        ...state,
        createInvoice: {
          loading: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case TAX_RATES_LOADING:
      return {
        ...state,
        taxRates: {
          ...state.taxRates,
          loading: true,
          error: null,
        },
      };
    case TAX_RATES_LOADED:
      return {
        ...state,
        taxRates: {
          ...state.taxRates,
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case TAX_RATES_FAILED:
      return {
        ...state,
        taxRates: {
          ...state.taxRates,
          loading: false,
          error: action.payload,
        },
      };
    case PAY_PREPAID_INVOICE_LOADING:
      return {
        ...state,
        payPrepaidInvoice: {
          ...state.payPrepaidInvoice,
          loading: true,
          success: false,
          error: null,
        },
      };
    case PAY_PREPAID_INVOICE_SUCCESS:
      return {
        ...state,
        payPrepaidInvoice: {
          loading: false,
          success: true,
          error: null,
          data: action.payload,
        },
      };
    case PAY_PREPAID_INVOICE_FAILED:
      return {
        ...state,
        payPrepaidInvoice: {
          loading: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case CUSTOMER_TAX_INFO_LOADING:
      return {
        ...state,
        customerTaxInfo: {
          ...state.customerTaxInfo,
          loading: true,
          error: null,
        },
      };
    case CUSTOMER_TAX_INFO_SUCCESS:
      return {
        ...state,
        customerTaxInfo: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case CUSTOMER_TAX_INFO_FAILED:
      return {
        ...state,
        customerTaxInfo: {
          loading: false,
          data: null,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default invoiceReducer;
